<template>
    <Modal v-model="seedFarmMemberBlackModal.show" width="800">
        <div slot="header">
            <span>黑名单</span>
        </div>
        <Form ref="form">
            <FormItem label="苗场" v-show="seedFarmMemberBlackModal.type === '单个'">
                <Select 
                    v-model="seedFarmMemberBlackModal.seedFarmUuid" 
                    style="width:200px" 
                    filterable
                    clearable
                    :transfer="true"
                >
                    <Option 
                        v-for="(item, index) in seedFarmList" 
                        :value="item.userBinFenSeedFarmRelateFarmUuid" 
                        :key="index">{{ item.userName }} - {{ item.seedFarmName }} - {{ item.userBinFenSeedFarmName }}</Option>
                </Select>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="primary" @click="confirm">确定</Button>
            <Button @click="cancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import search from '@/libs/search';
import { saveSeedFarmBlackUser } from '@/api/modules/seedFarm-management/seedFarm-member-back';
import { getBinFenSeedFarmUserList } from '@/api/modules/account-management/binFenSeedFarm-user-management';
export default {
    name: 'SeedFarmMemberBlackModal',
    components: {
    },
    data() {
        return {
            seedFarmMemberBlackModal: {
                show: false,
                userUuid: '',
                seedFarmUuid: '',
                type: '单个'
            },
            seedFarmList:[]
        };
    },
    methods: {
        confirm(){
            const { blackUserUuid, userUuid, seedFarmUuid } = this.seedFarmMemberBlackModal;
            let data={
                blackUserUuid: blackUserUuid,
                userUuid: userUuid,
                seedFarmUuid: seedFarmUuid,
                recordStatus: 1 
            };
            this.innerSpin = true;
            saveSeedFarmBlackUser(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.cancel();
                            this.$emit('refresh');
                        }
                    });
                }
            });
        },
        showModal(blackUserUuid, userUuid){
            this.seedFarmMemberBlackModal.show = true;
            this.seedFarmMemberBlackModal.seedFarmUuid = '';
            this.seedFarmMemberBlackModal.type = '单个';
            this.seedFarmMemberBlackModal.blackUserUuid = blackUserUuid;
            this.seedFarmMemberBlackModal.userUuid = userUuid;
            this.getSeedFarmList();
        },
        cancel() {
            this.seedFarmMemberBlackModal.show = false;
        },
	    getSeedFarmList(){
            let tableSearch = search.getSearchParams({ closeAllConditions: true });
            search.globalAddFilterConditionKey(tableSearch, "userBinFenSeedFarmApproval", "eq", 1, true);
            getBinFenSeedFarmUserList(tableSearch).then(res=>{
                if(res.code===0){
                    this.seedFarmList=res.data.records;
                    if(this.$checkAccessArray([ 'S' ])){
                        let all = {
                            isMainAccount: 1,
                            seedFarmName: "全部苗场",
                            userBinFenSeedFarmApproval: 1,
                            userBinFenSeedFarmContactNumber: "",
                            userBinFenSeedFarmLoginUuid: "all",
                            userBinFenSeedFarmName: "全部",
                            userBinFenSeedFarmRelateFarmUuid: "all",
                            userBinFenSeedFarmStatus: "",
                            userBinFenSeedFarmWechat: "",        
                            userName: "all"
                        };
                        this.seedFarmList.unshift(all);
                    }
                    
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>

</style>